if(!customElements.get('product-compare-popup')) {
    class ProductComparePopup extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            // close popup
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.close.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter' || e.key === ' '){
                        e.preventDefault();
                        this.close();
                    }
                });
            });
            this.addEventListener('click', e => {
                if(e.target === this) this.close();
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.close();
            });

            this.cartDrawer = document.querySelector('cart-drawer');
            this.addedToCartPopup = document.querySelector('added-to-cart-popup');

            this.onVariantChangeUnsubscriber = PubSub.subscribe(
                PubSub.events.optionValueSelectionChangeInCompareProduct, this.handleOptionValueChange.bind(this)
            );

            this.table = this.querySelector('.product-compare__table');
        }

        disconnectedCallback(){
            if(this.onVariantChangeUnsubscriber && typeof this.onVariantChangeUnsubscriber === 'function'){
                this.onVariantChangeUnsubscriber();
            }
        }

        open(triggerElement = null){
            this.previouslyFocusedElement = triggerElement || document.activeElement;

            this.showCompareProducts();

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            FocusTrap.activate(this);
            this.addFocus();
        }

        close(){
            FocusTrap.deactivate(this);

            this.setAttribute('inert', '');
            this.table.setAttribute('data-loaded', 'false');
            
            setTimeout(() => {
                this.setAttribute('data-hidden', 'true');
                
                if(this.previouslyFocusedElement){
                    this.previouslyFocusedElement.focus();
                }
            }, 300);

            document.body.style.overflow = 'initial';
            document.documentElement.style.overflow = 'initial';
        }

        addFocus(){
            const focusableElements = this.querySelectorAll('input, button, [tabindex]');
            if(focusableElements.length > 0){
                setTimeout(() => {
                    focusableElements[0].focus();
                }, 100);
            }
        }

        getProduct(requestUrl, index){
            this.abortController?.abort();
            this.abortController = new AbortController();
            this.pendingRequestUrl = requestUrl;

            fetch(`${requestUrl}&section_id=product-compare-popup-item`)
            .then(res => res.text())
            .then(resText => {
                this.pendingRequestUrl = null;
                const html = new DOMParser().parseFromString(resText, 'text/html');

                // display products in popup
                this.getProductInfo(html, index);
            })
            .catch(error => {
                if(error.name === 'AbortError') {
                    console.log('Fetch aborted by user');
                }else{
                    console.error(error);
                }
            }).finally(() => {
                this.table.setAttribute('data-loaded', 'true');
            });
        }

        showCompareProducts(){
            const compareProducts = JSON.parse(getCookie('compare-products') || sessionStorage.getItem('compare-products') || '[]');
            
            const productFields = this.querySelectorAll('[data-product-index]');
            productFields.forEach((field, index) => {
                const productIndex = parseInt(field.dataset.productIndex);
                if(productIndex <= compareProducts.length){ // valid index
                    field.setAttribute('data-hidden', 'false');

                    const product = compareProducts[productIndex-1];

                    if(product){
                        this.getProduct(product, productIndex);
                    }
                }else{
                    field.setAttribute('data-hidden', 'true');
                }
            });
        }

        onSubmitToCart(e, index){
            // handle error message
            this.handleErrorMessage(index);

            const form = this.querySelector(`[data-product-index="${index}"] form[data-type="add-to-cart-form"]`);
            if(!form) return;

            const buttonCart = e.currentTarget.querySelector('.button-cart');
            buttonCart.classList.add('disabled');
            buttonCart.classList.add('loading');

            const priceWrapper = this.querySelector(`[data-product-index="${index}"] .price-wrapper`);
            priceWrapper?.querySelector(".badge--sold-out")?.remove();

            const formData = new FormData(form);
            let error = false;

            // config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
            .then(res => res.json())
            .then(res => {
                if(res.status){
                    this.handleErrorMessage(res.description);

                    // sold out
                    if(buttonCart){
                        buttonCart.classList.remove('loading');
                        buttonCart.classList.remove('inner-group');
                    }

                    const soldoutBadge = document.createElement('span');
                    soldoutBadge.innerHTML = window.cart.badge.sold_out;
                    soldoutBadge.classList.add('badge', 'badge--sold-out', 'my-3', 'max-w-max');

                    if(priceWrapper){
                        priceWrapper.querySelectorAll(".badge").forEach(item => item.remove());

                        priceWrapper.querySelector(".price")?.append(soldoutBadge);
                        priceWrapper.querySelector('.price')?.classList.add('price--sold-out');
                        priceWrapper.querySelector('.price')?.classList.remove('price--on-sale');
                        priceWrapper.querySelector('.price')?.classList.remove('price--no-compare');
                        priceWrapper.querySelector('.price')?.classList.remove('volumn-pricing--sale-badge');
                    }

                    error = true;
                    return;
                }

                if(!this.cartDrawer){ // if cart drawer is disabled
                    window.location = window.routes.cart_url;
                    return;
                }

                error = false;

                if(this.addedToCartPopup){
                    this.addedToCartPopup.renderContent(res);
                }else{ // if added to cart popup is disabled
                    this.updateCartSize();
                }
            }).catch(e => {
                console.error(e);
            }).finally(() => {
                buttonCart.classList.remove('disabled');
                buttonCart.classList.remove('loading');

                setTimeout(() => {
                    this.close();
                }, 300);
            });
        }

        updateCartSize(){
            const cartIconURL = `/?section_id=header-cart-icon`;
            fetch(cartIconURL)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
                return res.text();
            }).then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                const header = document.querySelector('custom-header');
                const cartSizeIcons = header?.querySelectorAll('.cart-item-size');
                if(cartSizeIcons.length > 0){
                    cartSizeIcons.forEach(item => {
                        item.innerText = resultsMarkup.trim();
                        item.setAttribute('aria-hidden', 'false');
                    });
                }
            }).catch(e => {
                console.error(e);
            });
        }

        handleErrorMessage(index){
            const errorWrapper = this.querySelector(`[data-product-index="${index}"] .product-button .error`);
            if(!errorWrapper) return;

            errorWrapper.querySelector('small').innerText = `${message}`;
        }

        handleOptionValueChange({ data: { event, target, selectedOptionValues, variantIndex }}){
            if (!this.contains(event.target)) return;

            const productUrl = target.dataset.productUrl || this.pendingRequestUrl;
            const productId = target.dataset.optionValueId;
            this.pendingRequestUrl = productUrl;

            this.renderProductInfo({
                requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
                targetId: productId,
                callback: this.updateProductInfo(productUrl, variantIndex)
            });
        }

        updateProductInfo(productUrl, variantIndex){
            return (html) => {
                this.getProductInfo(html, variantIndex);
            }
        }

        getProductInfo(html, index){
            const productItem = html.querySelector('.product-item');
            if(productItem){
                const productFields = this.querySelectorAll(`[data-product-index="${index}"]`);
                productFields.forEach(field => {
                    const itemType = field.dataset.itemType;

                    if(productItem.querySelector(`.${itemType}`)){
                        field.innerHTML = productItem.querySelector(`.${itemType}`).innerHTML;

                        if(itemType === 'variant'){
                            const variantSelector = field.querySelector('variant-selector');
                            if(variantSelector){
                                const scripts = field.querySelectorAll('script');
                                const newScripts = [];
                                scripts.forEach(script => {
                                    if(script.getAttribute('type') !== 'application.json'){
                                        newScripts.push(script);
                                        script.remove();
                                    }
                                });

                                newScripts.forEach(script => {
                                    const newScript = document.createElement('script');
                                    if(script.src) {
                                        newScript.src = script.src;
                                    }else{
                                        newScript.textContent = script.textContent;
                                    }

                                    Array.from(script.attributes).forEach(attr => {
                                        newScript.setAttribute(attr.name, attr.value);
                                    });

                                    field.append(newScript);
                                });
                            }
                        }else if(itemType === 'product-button'){
                            const button = field.querySelector('.button-cart');
                            const form = field.querySelector('form');
                            if(button){
                                if(button.getAttribute('disabled') !== true){
                                    button.classList.remove('pointer-events-none');
                                }

                                if(form){
                                    form.addEventListener("submit", (e) => {
                                        e.preventDefault();
                                        this.onSubmitToCart(e, index);
                                    });
                                }
                            }
                        }else if(itemType === 'badge'){
                            const scripts = field.querySelectorAll('script');
                            const newScripts = [];
                            scripts.forEach(script => {
                                if(script.getAttribute('type') !== 'application.json'){
                                    newScripts.push(script);
                                    script.remove();
                                }
                            });

                            newScripts.forEach(script => {
                                const newScript = document.createElement('script');
                                if(script.src) {
                                    newScript.src = script.src;
                                }else{
                                    newScript.textContent = script.textContent;
                                }

                                Array.from(script.attributes).forEach(attr => {
                                    newScript.setAttribute(attr.name, attr.value);
                                });

                                field.append(newScript);
                            });
                        }else if(itemType === 'custom-field'){
                            const fieldItems = field.querySelectorAll(".custom-field-item");
                            const fieldKey = field.dataset.key;
                            
                            fieldItems.forEach(fieldItem => {
                                const itemKey = fieldItem.dataset.itemKey.trim();
                                if(itemKey.toLowerCase() === fieldKey.toLowerCase()){
                                    fieldItem.setAttribute('data-hidden', 'false');
                                }else{
                                    fieldItem.setAttribute('data-hidden', 'true');
                                }
                            });
                        }
                    }
                });
            }
        }

        renderProductInfo({ requestUrl, targetId, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(`${requestUrl}`, { signal: this.abortController.signal })
            .then((res) => res.text())
            .then((resText) => {
                this.pendingRequestUrl = null;
                const html = new DOMParser().parseFromString(resText, 'text/html');
                callback(html);
            })
            .catch((error) => {
                if(error.name === 'AbortError') {
                    console.log('Fetch aborted by user');
                }else{
                    console.error(error);
                }
            }).finally(() => {
                this.table.setAttribute('data-loaded', 'true');
            });
        }

        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false){
            const params = [];

            !shouldFetchFullPage && params.push(`section_id=product-compare-popup-item`);

            if(optionValues.length) {
                params.push(`option_values=${optionValues.join(',')}`);
            }

            return `${url}?${params.join('&')}`;
        }
    }

    customElements.define('product-compare-popup', ProductComparePopup);
}